import React from 'react';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import {
  ResponsiveContainer, AreaChart, Area,
} from 'recharts';
import {
  blueberry, frenchPink, caribbeanGreen, mellowApricot,
} from 'themes/colors';
import { movingAverage } from 'utils/report';

const useStyles = makeStyles(() => ({
  areaWrapper: {
    borderRadius: '0.375rem',
    '& .recharts-tooltip-wrapper': {
      zIndex: 1,
    },
  },
  area: {
    '& .recharts-area-curve': {
      strokeWidth: '0.188rem',
    },
    '& .recharts-area-area': {
    },
  },
}));

const strokeColor = (color) => {
  switch (color) {
    case 'blue':
      return blueberry;
    case 'pink':
      return frenchPink;
    case 'green':
      return caribbeanGreen;
    case 'yellow':
      return mellowApricot;
    default:
      break;
  }
  return blueberry;
};

const fillGradient = color => (`url(#${color}Gradient)`);

const LineChart = (props) => {
  const { graphData, chartColor, dataKey } = props;
  const classes = useStyles(props);
  const maData = movingAverage(graphData, dataKey);

  return (
    <ResponsiveContainer>
      <AreaChart
        className={classes.areaWrapper}
        width={120}
        height={50}
        data={maData}
      >
        <defs>
          <linearGradient id="blueGradient" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor={blueberry} stopOpacity={0.56} />
            <stop offset="95%" stopColor={blueberry} stopOpacity={0.1} />
          </linearGradient>
          <linearGradient id="pinkGradient" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor={frenchPink} stopOpacity={0.56} />
            <stop offset="95%" stopColor={frenchPink} stopOpacity={0.1} />
          </linearGradient>
          <linearGradient id="greenGradient" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor={caribbeanGreen} stopOpacity={0.56} />
            <stop offset="95%" stopColor={caribbeanGreen} stopOpacity={0.1} />
          </linearGradient>
          <linearGradient id="yellowGradient" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor={mellowApricot} stopOpacity={0.56} />
            <stop offset="95%" stopColor={mellowApricot} stopOpacity={0.1} />
          </linearGradient>
        </defs>
        <Area
          className={classes.area}
          type="basis"
          dataKey={dataKey}
          stroke={strokeColor(chartColor)}
          fill={fillGradient(chartColor)}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};

LineChart.propTypes = {
  chartColor: PropTypes.string,
  graphData: PropTypes.shape({}),
  dataKey: PropTypes.string,
};

LineChart.defaultProps = {
  graphData: null,
  chartColor: 'blue',
  dataKey: null,
};

export default LineChart;
